import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "./ui/Button";
import { surfaceStyles } from "./ui/styles";

export default function CommandPalette() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const paletteRef = useRef(null);

  const commands = [
    { id: "home", label: "Go Home", action: () => navigate("/") },
    { id: "profile", label: "Profile", action: () => navigate("/profile") },
  ];

  useEffect(() => {
    const handleKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  useEffect(() => {
    if (!open || !paletteRef.current) return;
    const focusable = paletteRef.current.querySelectorAll(
      "button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])",
    );
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    first?.focus();

    const handleKeyDown = (e) => {
      if (e.key !== "Tab") return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last?.focus();
        }
      } else if (document.activeElement === last) {
        e.preventDefault();
        first?.focus();
      }
    };

    const node = paletteRef.current;
    node.addEventListener("keydown", handleKeyDown);
    return () => node.removeEventListener("keydown", handleKeyDown);
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div
        ref={paletteRef}
        className={`${surfaceStyles.modal} w-full max-w-sm p-4`}
        role="dialog"
        aria-modal="true"
      >
        <h2 className="mb-2 text-lg text-text">Command Palette</h2>
        <ul>
          {commands.map((cmd) => (
            <li key={cmd.id} className="mb-2">
              <Button
                onClick={() => {
                  cmd.action();
                  setOpen(false);
                }}
                variant="secondary"
                className="w-full justify-start text-left"
              >
                {cmd.label}
              </Button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
